var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{attrs:{"fluid":"","src":_vm.isPharmacyAccount && _vm.getValueFromSource(_vm.pharmacyProfile, 'avatar.path') 
  ? _vm.getValueFromSource(_vm.pharmacyProfile, 'avatar.path') 
  : _vm.isLabAccount && _vm.getValueFromSource(_vm.labProfile, 'avatar.path') 
  ? _vm.getValueFromSource(_vm.labProfile, 'avatar.path') 
  : _vm.logoImage,"alt":"Login V2","width":_vm.width}})}
var staticRenderFns = []

export { render, staticRenderFns }